import { render, staticRenderFns } from "./CustomerMenuDropdown.vue?vue&type=template&id=66d0cc5e"
import script from "./CustomerMenuDropdown.vue?vue&type=script&lang=ts"
export * from "./CustomerMenuDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports